import { formatPhoneOrFallback } from '@/shared/utils/validation';
import { formatPersonName } from '@/shared/utils/personName';
import type { Patient } from '@/shared/types/patient';

/** Minimal patient fields needed for picker labels. */
export type PatientOptionFields = Pick<
  Patient,
  '_id' | 'name' | 'firstName' | 'lastName' | 'phone' | 'patientId'
>;

export const patientDisplayName = (patient: PatientOptionFields | null | undefined): string => {
  if (!patient) return '';
  return formatPersonName(patient, patient.name || '') || patient.patientId || patient._id;
};

/**
 * Value shown in the Autocomplete input after selection.
 * Example: `Nguyễn Văn An - 2608099`
 */
export const formatPatientInputLabel = (
  patient: PatientOptionFields | null | undefined
): string => {
  if (!patient) return '';
  const name = patientDisplayName(patient);
  const code = patient.patientId?.trim();
  return code ? `${name} - ${code}` : name;
};

/**
 * Secondary line in dropdown options.
 * Example: `2608099 · +84 912…`
 */
export const formatPatientOptionSecondary = (
  patient: PatientOptionFields | null | undefined,
  emptyPhoneLabel = '—'
): string => {
  if (!patient) return '';
  const code = patient.patientId?.trim() || '—';
  const phone = formatPhoneOrFallback(patient.phone, emptyPhoneLabel);
  return `${code} · ${phone}`;
};
